import { Download, Globe } from "lucide-react";
import { BsApple, BsWindows } from "react-icons/bs";
import { Button } from "../ui/button";
import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

interface DownloadDialogViewProps {
  version: string;
  downloads: readonly {
    label: string;
    detail: string;
    platform: "mac" | "windows";
    href: string;
  }[];
  betaUrl: string;
}

export default function DownloadDialogView({ version, downloads, betaUrl }: DownloadDialogViewProps) {
  return (
    <DialogContent className="max-h-[85dvh] w-[calc(100%_-_2rem)] max-w-lg overflow-y-auto rounded-lg">
      <DialogHeader>
        <DialogTitle>Download Stone</DialogTitle>
        <DialogDescription>Choose your computer. Version {version} includes in-app updates.</DialogDescription>
      </DialogHeader>
      <div className="grid gap-3">
        {downloads.map(({ label, detail, platform, href }) => {
          const PlatformIcon = platform === "mac" ? BsApple : BsWindows;
          return (
            <Button key={label} asChild variant="downloadOutline" className="h-auto justify-start gap-4 px-4 py-4">
              <a href={href}>
                <PlatformIcon size={24} aria-hidden="true" className="shrink-0" />
                <span className="flex-1 text-left">
                  <span className="block font-semibold">{label}</span>
                  <span className="block text-xs font-normal text-muted-foreground">{detail}</span>
                </span>
                <Download size={18} aria-hidden="true" className="shrink-0" />
              </a>
            </Button>
          );
        })}
      </div>
      <div className="border-t pt-4">
        <Button asChild variant="downloadOutline" className="w-full gap-2">
          <a href={betaUrl}><Globe size={18} aria-hidden="true" /> Try Beta Web Version</a>
        </Button>
        <p className="mt-2 text-center text-xs text-muted-foreground">Try Stone in your browser without installing.</p>
      </div>
    </DialogContent>
  );
}
